import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import IllustratedDivVertical from '../IllustratedDiv/IllustratedDivVertical.jsx'

export default class Search extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        imgAlt: PropTypes.string,
        imgSrc: PropTypes.string,
        icon: PropTypes.element,
        title: PropTypes.string,
        text: PropTypes.string,
        link: PropTypes.string,
        linkCalendly: PropTypes.string,
        linkText: PropTypes.string.isRequired,
      })
    ).isRequired
  }

  static defaultProps = {
    items: []
  }

  render() {
    return (
      <div className="container py-3 py-lg-5">
        <h2 className="mb-4 text-center">{this.props.title}</h2>
        <div className="search-container d-lg-flex flex-lg-wrap">
          {this.props.items.map((item, index) => (
            <IllustratedDivVertical
              key={index}
              icon={item.icon}
              imgSrc={item.imgSrc}
              imgAlt={item.imgAlt}
              title={item.title}
              text={item.text}
              link={item.link}
              linkCalendly={item.linkCalendly}
              linkText={item.linkText}
            />
          ))}
        </div>
      </div>
    )
  }
}
